import logo from './35th-reunion.jpg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="Photo of reunion attendees" />
      </header>
    </div>
  );
}

export default App;
